var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7531.95,-1814.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-black",
    transform: "matrix(0.145417,0,0,0.186342,7128.42,1755.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49020.7,-9421.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7552.13,1835.77L7559.48,1843.12C7559.74,1843.38 7560.16,1843.38 7560.42,1843.12C7560.68,1842.86 7560.68,1842.44 7560.42,1842.18L7553.07,1834.83C7554.64,1833.04 7555.59,1830.7 7555.59,1828.13C7555.59,1822.53 7551.04,1817.98 7545.44,1817.98C7539.83,1817.98 7535.28,1822.53 7535.28,1828.13C7535.28,1833.74 7539.83,1838.29 7545.44,1838.29C7548,1838.29 7550.34,1837.34 7552.13,1835.77ZM7551.68,1834.37L7551.66,1834.38C7550.07,1835.97 7547.87,1836.96 7545.44,1836.96C7540.57,1836.96 7536.61,1833 7536.61,1828.13C7536.61,1823.27 7540.57,1819.31 7545.44,1819.31C7550.3,1819.31 7554.26,1823.27 7554.26,1828.13C7554.26,1830.57 7553.27,1832.77 7551.68,1834.37Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0ddd22c1ee608f4a4f7ec7b2c2d5a9b2.svg";
export { ForwardRef as ReactComponent };